<template>
    <div class="inputNumber">
        <button class="sub" @click="sub"></button>
        <input type="number" onwheel="return false" step="1" min="1" oninput="validity.valid||(value='')"  v-model="value" @input="changeValue(Number($event.target.value))">
        <button class="add" @click="add"></button>
    </div>
</template>

<script>

export default {
    name: 'inputNumber',
    props: {
        val: {

        }
    },
    components: {

    },

    data() {
        return {
            value: 1
        } 
    },  
    methods: { 
        changeValue(value) {
            if(value > 0) {
                this.$emit('input', value)
            }
        },

        sub() {
            if(this.value != 1) {
                this.value --
                this.$emit('input', this.value)
            }
        },

        add() {
            this.value ++
            this.$emit('input', this.value)
        }
        
    },
    created() {
        this.value = this.val
    }
}
</script>

<style scoped>
input[type=number] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
input[type=text] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.inputNumber {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
input {
  width: 70px;
  height: 32px;
  border: 0;
  background: #ffff;
  color: rgb(43, 43, 43);
  -webkit-box-shadow: 0 10px 65px -10px rgba(0, 0, 0, 0.25);
          box-shadow: 0 10px 65px -10px rgba(0, 0, 0, 0.25);
  text-align: center;
  font-size: 1rem;
  border-top: 1px solid rgb(230, 230, 230);
  border-bottom: 1px solid rgb(230, 230, 230);
  -webkit-appearance: none;
    -moz-appearance: none;
    border-radius: 0px;
    -webkit-border-radius: 0;
    box-sizing: border-box;
}
input:focus {
    outline: none;
}
button {
    height: 32px;
    width: 40px;
    margin: 0;
    border: 0;
    background: rgb(255, 255, 255)
        url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="50"><path d="M17 25h16M67 25h16M75 17v16" fill="none" stroke="rgb(59,69,66)" stroke-width="1.5px" stroke-linecap="round" stroke-linejoin="round" /></svg>')
        no-repeat 0 0;
    background-size: 5.1rem 2.5rem;
    background-position-y: -5px;
    background-position-x: -1px;
    overflow: hidden;
    white-space: nowrap;
    text-indent: 100%;
    border-radius: 0rem;
    cursor: pointer;
    -webkit-transition: opacity 0.15s;
    -o-transition: opacity 0.15s;
    transition: opacity 0.15s;
    opacity: .9;
}

button:active {
    background-position-y: -5px;
    -webkit-box-shadow: inset 0 2px 12px -4px #c5d1d9;
        box-shadow: inset 0 2px 12px -4px #c5d1d9;
}

button:focus {
    outline: none;
}

button:hover {
    opacity: 1;
}
button.sub {
    left: 5.4rem;
    border: 1px solid rgb(230, 230, 230);
    border-right: 1px solid rgb(235, 235, 235);
    border-radius: 7px 0px 0px 7px;
}

button.add {
    right: 0.6rem;
    background-position-x: -2.6rem;
    border: 1px solid rgb(230, 230, 230);
    border-left: 1px solid rgb(235, 235, 235);
    border-radius: 0px 7px 7px 0px;
}

</style>